import { useContext, useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';

import { AppContext } from '../../App.context';
import { byReleaseDate } from '../../hooks/use-issue';

import { Issue, getImagesFromIssue } from '../../constants';
import config from '../../config';

export function useGetIssues(): GetIssuesResponse {
	const { graphQLClient, sw } = useContext(AppContext);
	const [issues, setIssues] = useState<Array<Issue>>([]);
	const cacheTime = 1000 * 60 * (config.app?.cache?.ttl?.getAllIssues || 60);
	const { data, isPending, error } = useQuery<IssuesQuery>({
		queryKey: ['issues'],
		queryFn: async () => graphQLClient.request(issuesQueryDocument),
		staleTime: cacheTime,

		gcTime: cacheTime,
	});
	useEffect(() => {
		if (!data) return;

		if (sw) {
			const images: Set<string> = new Set();
			getImagesFromIssue(images, issues);
			if (images.size) {
				sw.postMessage({
					type: 'DOWNLOAD_BACKGROUND_IMAGES',
					payload: {
						images: [...images],
					},
				});
			}
		}

		setIssues(data.issues);
	}, [data, sw]);
	return {
		issues: issues.sort(byReleaseDate),
		isLoading: isPending,
		error,
	};
}

interface GetIssuesResponse {
	issues: Array<Issue>;
	isLoading: boolean;
	error?: Error | null;
}

interface IssuesQuery {
	issues: Issue[];
}

export const issuesQueryDocument = gql`
	query Issues {
		issues {
			id
			name
			description
			cover
			externalUrl
			price
			index
			slug
			currency
			data
			updated
			created
			releaseDate
			isPurchased
			isPaid
		}
	}
`;
